export const GROUP_NAME_MAX_LENGTH = 255
export const GROUP_DESC_MAX_LENGTH = 100
export const GROUP_SCHEMAS = Object.freeze({
  ENTIRE: 'urn:ietf:params:scim:schemas:core:2.0:Group',
  PARTIAL: 'urn:ietf:params:scim:schemas:extensions:hpe-greenlake:2.0:Group',
  PATCH_OP_SCHEMA: 'urn:ietf:params:scim:api:messages:2.0:PatchOp'
})
